import clsx from "clsx";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export enum ActionGroups {
  Cache = "cache",
  Performance = "performance",
}

export enum Actions {
  ClearCache = "cache",
  ClearLocalStorage = "local_storage",
  Raster = "raster",
  RasterOwnership = "raster_ownership",
  HiddenLayers = "hidden",
  HiddenSites = "hidden_sites",
  VectorAPI = "vector",
  Logging = "logging",
  MVTSites = "mvt_sites",
}

type ActionType = PropsWithChildren & { name: string; group: string; action?: () => void };

export const Action = ({ group, name, action, children }: ActionType) => {
  const { t } = useTranslation();

  return (
    <li
      className={clsx(
        "flex items-center justify-between py-4 px-3 hover:bg-platform-50",
        action ? " cursor-pointer" : ""
      )}
      onClick={action}
    >
      <div className="flex flex-col">
        <p className="font-medium text-neutral-900 text-sm/6">
          {t(`nav.debug_modal.action_group.${group}.action.${name}.title`)}
        </p>
        <p className="text-xs text-neutral-500">
          {t(`nav.debug_modal.action_group.${group}.action.${name}.description`)}
        </p>
      </div>
      <div className="shrink-0 min-w-[120px] flex justify-end">{children}</div>
    </li>
  );
};

type ActionGroupType = PropsWithChildren & { name: string };
export const ActionGroup = ({ name, children }: ActionGroupType) => {
  const { t } = useTranslation();
  return (
    <div className="py-2">
      <div>
        <h2 className="text-lg/6 font-medium text-neutral-900">{t(`nav.debug_modal.action_group.${name}.title`)}</h2>
        <p className="mt-1 text-sm text-neutral-500">{t(`nav.debug_modal.action_group.${name}.description`)}</p>
      </div>
      <ul role="list" className="mt-2 divide-y divide-neutral-200">
        {children}
      </ul>
    </div>
  );
};
